import { useMemo, useRef } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { toast } from "sonner";
import api, { apiError } from "./api";

export const RichTextEditor = ({ value, onChange, testId, placeholder = "Γράψε το περιεχόμενο…" }) => {
    const quillRef = useRef(null);

    const modules = useMemo(
        () => ({
            toolbar: {
                container: [
                    [{ header: [2, 3, false] }],
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["blockquote", "link", "image"],
                    ["clean"],
                ],
                handlers: {
                    image: () => {
                        const input = document.createElement("input");
                        input.type = "file";
                        input.accept = "image/jpeg,image/png,image/webp,image/gif";
                        input.onchange = async () => {
                            const file = input.files?.[0];
                            if (!file) return;
                            const fd = new FormData();
                            fd.append("file", file);
                            try {
                                const res = await api.post("/api/admin/upload", fd);
                                const quill = quillRef.current?.getEditor();
                                if (!quill) return;
                                const range = quill.getSelection(true);
                                quill.insertEmbed(range ? range.index : quill.getLength(), "image", res.data.url);
                                toast.success("Η εικόνα προστέθηκε.");
                            } catch (e) {
                                toast.error(apiError(e, "Το ανέβασμα της εικόνας απέτυχε."));
                            }
                        };
                        input.click();
                    },
                },
            },
        }),
        []
    );

    return (
        <div className="admin-quill" data-testid={testId}>
            <ReactQuill
                ref={quillRef}
                theme="snow"
                value={value}
                onChange={onChange}
                modules={modules}
                placeholder={placeholder}
            />
        </div>
    );
};
